import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	obligatoryUimGicConsentMessage: {
		id: 'ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message',
		defaultMessage:
			'You must allow "{appTitle}" to access your Atlassian products to create this issue.',
		description:
			'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied',
	},
	obligatoryUimGicConsentMessageIssueTermRefresh: {
		id: 'ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message-issue-term-refresh',
		defaultMessage:
			'You must allow "{appTitle}" to access your Atlassian products to create this work item.',
		description:
			'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied',
	},
});
